var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadges(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Badges_svg__clip0_2004_32)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Badges_svg__clip1_2004_32)",
    strokeWidth: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.595 334.714h240.167c52.559 0 95.238 42.678 95.238 95.238v298.083c0 6.572-5.333 11.905-11.905 11.905h-323.5c-6.571 0-11.905-5.333-11.905-11.905V346.619c0-6.572 5.334-11.905 11.905-11.905zM835.405 739.928h-323.5c-6.572 0-11.905-5.333-11.905-11.905V429.94c0-52.559 42.679-95.238 95.238-95.238h240.167c6.571 0 11.905 5.333 11.905 11.905v381.416c0 6.572-5.334 11.905-11.905 11.905z",
    fill: "#E2142D",
    stroke: "#E2142D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.69 302.893h238.977c45.988 0 83.333 37.345 83.333 83.333v321.893H177.69V302.893zM822.31 708.119H500V386.226c0-45.988 37.345-83.333 83.333-83.333H822.31v405.226z",
    fill: "#fff",
    stroke: "#CAE0E3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.667 638.119H177.69v70h321.239c-6.381-39.678-40.774-70-82.262-70zM583.333 638.119h238.976v70H501.071c6.381-39.678 40.774-70 82.262-70z",
    fill: "#CAE0E3",
    stroke: "#95C2C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.06 673.119h194.797M778.94 673.119H584.143",
    stroke: "#95C2C7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.048 583.047c21.493 0 38.916-17.423 38.916-38.916 0-21.494-17.423-38.917-38.916-38.917-21.494 0-38.917 17.423-38.917 38.917 0 21.493 17.423 38.916 38.917 38.916z",
    fill: "#FA505E",
    stroke: "#F93444",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.643 583.047c21.493 0 38.916-17.423 38.916-38.916 0-21.494-17.423-38.917-38.916-38.917s-38.917 17.423-38.917 38.917c0 21.493 17.424 38.916 38.917 38.916z",
    fill: "#40A9D6",
    stroke: "#4084D6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.048 451.5c21.493 0 38.916-17.424 38.916-38.917 0-21.493-17.423-38.916-38.916-38.916-21.494 0-38.917 17.423-38.917 38.916s17.423 38.917 38.917 38.917z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.643 451.5c21.493 0 38.916-17.424 38.916-38.917 0-21.493-17.423-38.916-38.916-38.916s-38.917 17.423-38.917 38.916S385.15 451.5 406.643 451.5z",
    fill: "#46C65E",
    stroke: "#1E9561",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.357 583.047c21.493 0 38.917-17.423 38.917-38.916 0-21.494-17.424-38.917-38.917-38.917-21.493 0-38.917 17.423-38.917 38.917 0 21.493 17.424 38.916 38.917 38.916z",
    fill: "#A446C6",
    stroke: "#771E95",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.952 583.047c21.493 0 38.917-17.423 38.917-38.916 0-21.494-17.424-38.917-38.917-38.917-21.493 0-38.916 17.423-38.916 38.917 0 21.493 17.423 38.916 38.916 38.916z",
    fill: "#FA99A1",
    stroke: "#FA6975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.357 451.5c21.493 0 38.917-17.424 38.917-38.917 0-21.493-17.424-38.916-38.917-38.916-21.493 0-38.917 17.423-38.917 38.916s17.424 38.917 38.917 38.917z",
    fill: "#FD934F",
    stroke: "#FA505E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.952 451.5c21.493 0 38.917-17.424 38.917-38.917 0-21.493-17.424-38.916-38.917-38.916-21.493 0-38.916 17.423-38.916 38.916s17.423 38.917 38.916 38.917z",
    fill: "#2A848E",
    stroke: "#006C78",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Badges_svg__clip0_2004_32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Badges_svg__clip1_2004_32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadges);
export default ForwardRef;